import angular from 'angular'

angular.module('pub.product_lines', []).controller('RelatedCtrl', RelatedCtrl)

/** @ngInject */
function RelatedCtrl($scope, $state, $stateParams, $timeout, ChannelsService) {
  var vm = this
  vm.items = []
  vm.parentId = $stateParams.parentId
  vm.model = {}
  vm.totalUsers = 0
  vm.usersPerPage = 25
  vm.oldPage = 0
  vm.currentPage = 25
  vm.first = true
  vm.totalItems = 0
  vm.pagination = {
    current: 1,
  }

  ChannelsService.listSets(vm.parentId).then(function(result) {
    vm.sets = result.results
  })

  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }
    ChannelsService.listRelated(vm.parentId, vm.oldPage, 25, 'ts-desc').then(function(result) {
      var sets = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < sets.length; i++) {
        sets[i].editing = false
      }
      vm.items = sets
    })
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  vm.add = function() {
    vm.setId = null
    $('#myModal').modal('show')
  }

  vm.save = function(item) {
    ChannelsService.saveRelated(vm.parentId, vm.setId, item).then(
      function() {
        load(vm.pagination.current)
      },
      function(err) {
        $timeout(function() {
          if (err.error === undefined) {
            swal('Set does not exist', '', 'error')
            return
          }

          swal(err.error.message, '', 'error')
        }, 300)
      },
    )
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want delete this related set',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChannelsService.deleteRelated(vm.parentId, item.id).then(function() {
            load(vm.pagination.current)
          })
        }
      },
    )
  }

  vm.back = function() {
    load(vm.pagination.current)
  }

  vm.selectSet = function() {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want to associate this Set',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          $('#myModal').modal('hide')
          var model = {
            'id-ch': parseInt(vm.parentId),
            'id-s': parseInt(vm.setId),
          }
          vm.save(model)
        }
      },
    )
  }
}
